import React, { useEffect, useState } from 'react';
import { Affix, Button, Card, Divider, message, Result, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import {
  getPoiGroupByIdAction,
  savePoiGroupAction,
} from '../../../actions/AppCms/PoiGroupActions';
import { history } from '../../../utils/history';
import Authorized from '../../../components/Authorization/Authorized';
import AuditTrail from '../../../components/AuditTrail/AuditTrail';

import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const AddPoiGroup = ({ match, form }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [finished, setFinished] = useState(false);
  // const [exportButtonClicked, setExportButtonClicked] = useState(false);
  const [itemId, setItemId] = useState(0);

  const { poiGroup } = useSelector(store => ({
    poiGroup: store.poiGroupReducer.poiGroup,
  }));

  useEffect(() => {
    dispatch(getCmsLanguagesAction());
    const { id } = match.params;
    setItemId(id);

    if (id > 0) {
      dispatch(getPoiGroupByIdAction(id));
    }
  }, []);

  const handleGoPoiGroups = () => {
    history.push('/poi-groups');
  };

  const handleGoAddNew = () => {
    history.push('/add-poi-group');
  };

  const handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        if (!err) {
          const values = {
            title: fieldsValue.title,
            image: fieldsValue.image ? fieldsValue.image[0] : null,
          };


          if (itemId > 0) {
            dispatch(savePoiGroupAction(values, itemId)).then(() => {
              message.success(t('appCms.poiGroup.successfullySaved'));
              setFinished(true);
            });
          }
        }
      }
      // else {
      //   if (err.dateOfWork) {
      //     message.error(err.dateOfWork.errors[0].message);
      //   }
      //   if (err.conditionCategory) {
      //     message.error(err.conditionCategory.errors[0].message);
      //   }
      //   if (err.itemObject) {
      //     message.error(err.itemObject.errors[0].message);
      //   }
      // }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 16 },
      lg: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent
      title={t('appCms.poiGroup.updatePoiGroup')}
      subTitle={t('appCms.poiGroup.pointOfInterestGroup')}
    // exportButton={
    //   <Button type="primary" onClick={() => handleExport()}>
    //     Export PDF
    //   </Button>
    // }
    >
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          <Card
            title={t('appCms.general')}
            bordered={false}
            extra={
              <Affix offsetTop={10}>
                <Authorized asset="appcms" operation="write">
                  <Button type="primary" htmlType="submit">
                    {t('common.save')}
                  </Button>
                </Authorized>
              </Affix>
            }
          >
            <General form={form} reportData={poiGroup} submit={handleSubmit} />
          </Card>
          <Authorized asset="appcms" operation="write">
            <Divider />
            <Row type="flex" justify="center">
              <Button type="primary" htmlType="submit">
                {t('common.save')}
              </Button>
            </Row>
            <Divider />
            <AuditTrail
              objectId={itemId}
              objectType="point of interest group"
            />
          </Authorized>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title={t('appCms.poiGroup.successfullySaved')}
          // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
          extra={[
            <Button type="primary" key="console" onClick={handleGoPoiGroups}>
              {t('appCms.poiGroup.goToPoiGroups')}
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              {t('appCms.poiGroup.addPoiGroup')}
            </Button>,
          ]}
        />
      )}
    </CustomAddNewPageContent>)
  );
};

AddPoiGroup.propTypes = {
  form: PropTypes.object,
  savePoiGroupAction: PropTypes.func,
  getPoiGroupByIdAction: PropTypes.func,
  match: PropTypes.object,
  poiGroup: PropTypes.object,
};

const WrappedPoiGroupForm = Form.create({
  name: 'WrappedPoiGroup',
})(AddPoiGroup);

function mapStateToProps() {
  return {};
}

const WrappedAddPoiGroup = connect(mapStateToProps, {})(WrappedPoiGroupForm);

export default WrappedAddPoiGroup;
